import { usePersistedState } from "@swa-ui/persistence";

/**
 * useChaseStorage provides hooks for getting, setting, and clearing chase storage.
 * chaseStorage is used to pass information between the vision flows and spa-air-seat.
 **/

export const useChaseStorage = () => {
  const [chaseStorage, setChaseStorage] = usePersistedState({
    defaultValue: {
      returnUrl: null,
    },
    key: "chaseStorage",
    onExpiration: clearChaseStorage,
    persist: "session",
    timeToLiveInMinutes: 30,
  });

  function getChaseStorage() {
    return chaseStorage;
  }

  function clearChaseStorage() {
    setChaseStorage(() => ({}));
  }

  return {
    clearChaseStorage,
    getChaseStorage,
    chaseStorage,
    setChaseStorage,
  };
};
